import { useCallback } from "react";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { convertToViewModelToInput } from "./composition/convert-view-model-to-input";
import { RoomStockUpdate_StockManagementPage } from "./mutation";

import type { RoomStockDiffStore } from "../../../usecase/use-create-form-model/room-stock-diff-store";
import type { ServerModel } from "../../../usecase/use-create-form-model/type";

type Props = {
	onReInitialize: () => void;
	serverModel: ServerModel;
	roomStockDiffStore: RoomStockDiffStore;
};

export const useUpdateRoomStock = ({ onReInitialize, serverModel, roomStockDiffStore }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(RoomStockUpdate_StockManagementPage);

	const onUpdateRoomStock = useCallback(async () => {
		showLoadingScreenCallback();

		const input = convertToViewModelToInput({ serverModel, roomStockDiffStore });

		const { errors } = await mutationFunc({
			variables: {
				input,
			},
		}).finally(() => {
			hideLoadingScreenCallback();
		});

		if (!errors) {
			notifyUserEventInfo({
				title: "部屋在庫を更新しました",
			});

			onReInitialize();
		}
	}, [
		showLoadingScreenCallback,
		serverModel,
		roomStockDiffStore,
		mutationFunc,
		hideLoadingScreenCallback,
		onReInitialize,
	]);

	return {
		onUpdateRoomStock,
	};
};
